import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
  routes: [
    {
      path: '/',
      name: 'motionFocus',
      component: () =>
        import('@/views/motionFocus.vue')
    },
    {
      path: '/partInquriy',
      name: 'partInquriy',
      component: () =>
        import('@/views/partInquriy.vue')
    },
    {
      path: '/partInquriyDetail',
      name: 'partInquriyDetail',
      component: () =>
        import('@/views/partInquriyDetail.vue')
    },
    {
      path: '/priceSearch',
      name: 'priceSearch',
      component: () =>
        import('@/views/priceSearch.vue')
    },
    {
      path: '/priceSearchDetail',
      name: 'priceSearchDetail',
      component: () =>
        import('@/views/priceSearchDetail.vue')
    },
    {
      path: '/today',
      name: 'today',
      component: () =>
        import('@/views/today.vue')
    },
    {
      path: '/orderDetail/:orderNo',
      name: 'orderDetail',
      component: () =>
        import('@/views/orderDetail.vue')
    },
    {
      path: '/userCenter',
      name: 'userCenter',
      component: () =>
        import('@/views/userCenter.vue')
    },
    {
      path: '/userCenterDetail/:userCode',
      name: 'userCenterDetail',
      component: () =>
        import('@/views/userCenterDetail.vue')
    },
    {
      path: '/ihuberr/:status/:message',
      name: 'ihuberr',
      component: () =>
        import('@/views/ihuberr.vue')
    }
  ]
})

export default router
